import { createRouter, createWebHistory } from 'vue-router'

import sessionStore from '@shared/store/session'

import useApplication from '@shared/hooks/useApplication'
import useI18n from '@shared/hooks/useI18n'

import { DEFAULT_FOCUS_DELAY, PACKAGE } from '@shared/config/constants'
import { ROUTE_NAME } from '@cOffer/constants'

// HOOKS
const { changeLanguage } = useApplication()
const { selectedLanguage } = useI18n()

const Router = createRouter({
  history: createWebHistory(import.meta.env.VITE_PATH_COFFER),
  routes: [
    {
      name: ROUTE_NAME.C_OFFER,
      path: '/',
      strict: true,
      redirect: _to => `/${selectedLanguage.value.toLowerCase()}`,
      meta: {
        navigation: false,
        headerDisabled: true,
      },
    },
    {
      path: '/:lang',
      component: () => import('@shared/modules/COffer/components/COffer'),
      children: [
        {
          name: ROUTE_NAME.C_OFFER_OVERVIEW,
          path: '',
          component: () => import('@shared/modules/COffer/components/Overview'),
        },
        {
          name: ROUTE_NAME.C_OFFER_SUCCESS,
          path: 'success',
          component: () => import('@shared/modules/COffer/components/Success'),
        },
      ],
    },
  ],
  scrollBehavior(to) {
    // can be aborted via query-option on caller
    if (to.query.scrollTop === 'false') {
      return Promise.resolve()
    }

    // can be aborted via meta-option on route
    if (to.meta?.scrollTop === false) {
      return Promise.resolve()
    }

    if (window.pageYOffset > 0) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            top: 0,
            behavior: 'smooth',
          })
        }, DEFAULT_FOCUS_DELAY)
      })
    }
  }
})

Router.beforeEach(async (to, _from) => {
  const routeLanguage = to.params.lang.toUpperCase()
  await changeLanguage({ language: routeLanguage, additionalApps: [PACKAGE.PRODUCTS] })

  // Get cookie data
  const sessionBasket = sessionStore.getSession()

  // Set session store (to save jwtoken for api-calls)
  sessionStore.setSession(sessionBasket)

  if (!sessionBasket || !sessionBasket.hot) {
    console.log('Error Page?')
  }
})

export default Router
